import styled from "styled-components"

import Subtitle from "./Subtitle"

const SubtitleH1 = styled.p`
  ${Subtitle}

  font-size: 22px;
`

export default SubtitleH1
